import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { useDeleteUser, usePostUsersSendUserInvites } from 'api';

import ToastMessage from 'components/toastMessage';
import { Box, Button } from 'components/ui';

import { DeleteConfirmationModal, InviteUserModal, ListItem } from './components';

import * as Styled from './SettingsUsers.styles';

export const SettingsUsers = ({ usersData, refetchUsersData }) => {
  const [isInviteModal, setIsInviteModal] = useState(false);
  const [deleteUserData, setDeleteUserData] = useState(null);
  const [toastData, setToastData] = useState(null);

  const { mutate: deleteUser, isLoading: isDeletingUser } = useDeleteUser({
    onSuccess: () => {
      refetchUsersData();
      setDeleteUserData(null);
    },
  });
  const { mutate: inviteUsers, isLoading: isInvitingUsers } = usePostUsersSendUserInvites({
    onSuccess: () => {
      refetchUsersData();
      setIsInviteModal(false);
    },
  });

  const activeUsers = useMemo(() => (usersData || []).filter((user) => user.user.isAuthenticated), [usersData]);
  const inactiveUsers = useMemo(() => (usersData || []).filter((user) => !user.user.isAuthenticated), [usersData]);

  return (
    <Box title="Użytkownicy">
      <Button onClick={() => setIsInviteModal(true)}>Zaproś użytkowników</Button>

      <Styled.List>
        <Styled.Label>Aktywni</Styled.Label>
        {activeUsers.map((user) => (
          <ListItem key={user.id} item={user.user} onDelete={() => setDeleteUserData(user)} />
        ))}
      </Styled.List>

      {inactiveUsers.length > 0 && (
        <Styled.List>
          <Styled.Label>Nieaktywni</Styled.Label>
          {inactiveUsers.map((user) => (
            <ListItem key={user.id} item={user.user} onDelete={() => setDeleteUserData(user)} />
          ))}
        </Styled.List>
      )}

      {toastData && (
        <ToastMessage
          open
          onClose={() => setToastData(null)}
          severity={toastData.severity}
          message={toastData.message}
        />
      )}

      {isInviteModal && (
        <InviteUserModal
          existingEmails={(usersData || []).map((user) => user.user.email)}
          onClose={() => setIsInviteModal(false)}
          onConfirm={(emails) => inviteUsers({ invites: emails })}
          isSaving={isInvitingUsers}
        />
      )}

      {deleteUserData && (
        <DeleteConfirmationModal
          onClose={() => setDeleteUserData(null)}
          onConfirm={() => deleteUser(deleteUserData.id)}
          isDeleting={isDeletingUser}
        />
      )}
    </Box>
  );
};

SettingsUsers.propTypes = {
  usersData: PropTypes.object.isRequired,
  refetchUsersData: PropTypes.func.isRequired,
};
